if (!customElements.get('grid-load-more')) {
  customElements.define('grid-load-more', class GridLoadMore extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.loader = this.querySelector('[data-loader]');
      this.stepSize = 12; // Set fixed step size here
    }

    connectedCallback() {
      if (!this.button) return;
      this.initialize();
    }

    initialize() {
      if (this.dataset.infinite === 'true') this.requested = false;
      this.setListeners();
    }

    setListeners() {
      this.loadMore = this.onLoadMore.bind(this);
      this.button.addEventListener('click', this.loadMore);
      if (this.dataset.infinite === 'true') {
        window.addEventListener('scroll', this.loadInfinite.bind(this));
      }
    }

    loadInfinite() {
      const handleObserver = (entries, observer) => {
        observer.unobserve(this);
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (this.requested) return;
            this.button.dispatchEvent(new Event('click'));
            this.requested = true;
          } else {
            this.requested = false;
          }
        });
      };
      new IntersectionObserver(handleObserver, { rootMargin: '0px 0px -60px 0px' }).observe(this);
    }

    onLoadMore(event) {
      event.preventDefault();
      this.button.classList.add('disabled');
      this.loader.classList.remove('hidden');
      this.showButton = true;
    
      const tempDiv = document.createElement('div');
      const paginationCount = document.getElementById('pagination-count');
      const stepSize = parseInt(paginationCount?.dataset.stepSize || 12, 10); // fallback to 12 if missing
    
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          tempDiv.innerHTML = text;
    
          const newColumns = tempDiv.querySelectorAll('[data-render-columns]');
          const paginationWrapper = document.querySelector('[data-paging-loader-parent]');
          const newPagination = tempDiv.querySelector('[data-paging-loader-parent]');
          const parentNode = paginationWrapper.parentNode;
    
          newColumns.forEach(column => {
            parentNode.insertBefore(column, paginationWrapper);
            
            // Re-initialize dynamic elements if needed
            const atcBtn = column.querySelector('atc-submit-form');
            if (atcBtn) atcBtn.initialize?.();
    
            const variantChanger = column.querySelector('single-variant');
            if (variantChanger) variantChanger.initialize?.();
          });
    
          // ✅ Dynamically update "Viewing X - Y of Z"
          if (paginationCount) {
            const total = parseInt(paginationCount.dataset.total, 10);
            let currentTo = parseInt(paginationCount.dataset.to, 10);
            const newTo = Math.min(currentTo + stepSize, total);
    
            paginationCount.setAttribute('data-to', newTo);
            paginationCount.textContent = `Viewing 1 - ${newTo} of ${total} items`;
          }
    
          // Replace pagination if new content has it
          if (newPagination) {
            paginationWrapper.innerHTML = newPagination.innerHTML;
          } else {
            this.showButton = false;
          }
        })
        .catch(console.error)
        .finally(() => {
          if (!this.showButton) return this.hideButton();
          this.button.classList.remove('disabled');
          this.loader.classList.add('hidden');
        });
        // Samita
        typeof Samita !== "undefined" && typeof Samita.ProductLabels !== "undefined" && Samita.ProductLabels.init();
    }

    hideButton() {
      const parent = this.parentElement;
      parent.style.display = 'none';
    }
  });
}
